import React from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import {
  getEsRestHost, getEsRestPort, getEsRestUrl, isAirActive,
} from 'dmpconnectjsapp-base/helpers/accessors';
import { connect } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';

function CheckConnectorRest({ air, restConnectorUrl }) {
  const connectorName = `DmpConnect-ES REST${air === true ? ' AIR' : ''}`;

  return (
    <Card id="connector_not_running">
      <Card.Header>Connecteur DMP injoignable</Card.Header>
      <Card.Body>
        <Alert variant="info" className="d-flex align-items-center justify-content-between">
          <span>
            <i className="la la-info-circle mr-1" />
            En attente d&apos;une réponse du connecteur
          </span>
          <Spinner animation="border" size="sm" />
        </Alert>
        <Card.Text>
          Veuillez vérifier que le connecteur
          {' '}
          {connectorName}
          {' '}
          est joignable à l&apos;adresse configurée :
          {' '}
          <span className="font-italic">{restConnectorUrl}</span>
          .
        </Card.Text>
      </Card.Body>
    </Card>
  );
}

CheckConnectorRest.propTypes = {
  air: PropTypes.bool.isRequired,
  restConnectorUrl: PropTypes.string.isRequired,
};
function mapStateToProps(state) {
  const esRestHost = getEsRestHost(state);
  const esRestPort = getEsRestPort(state);
  const esRestUrl = getEsRestUrl(state);

  return {
    air: isAirActive(state),
    restConnectorUrl: !esRestHost && !esRestUrl ? 'Aucune URL définie' : esRestUrl || `${esRestHost}:${esRestPort}`,
  };
}

export default connect(mapStateToProps)(CheckConnectorRest);
